// protocol/registry.ts
import { actionModules } from './actions.gen';
import { eventModules } from './events.gen';
import { isActionDef, type ActionDef } from './define';
/** Augmented by protocol/actions/*.ts: `'type': { req: …; res: … }`. */
// eslint-disable-next-line @typescript-eslint/no-empty-object-type -- augmented by every protocol/actions/*.ts file
export interface ActionMap {}
/** Augmented by protocol/events/*.ts: `'kind': payload`. */
// eslint-disable-next-line @typescript-eslint/no-empty-object-type -- augmented by every protocol/events/*.ts file
export interface EventMap {}
export type ActionType = keyof ActionMap & string;
export type ActionReq<T extends ActionType> = ActionMap[T] extends { req: infer Q } ? Q : never;
export type ActionRes<T extends ActionType> = ActionMap[T] extends { res: infer R } ? R : never;
export type EventKind = keyof EventMap & string;
export type TownEvent = { [K in EventKind]: { k: K } & EventMap[K] }[EventKind];
export type EventOf<K extends EventKind> = Extract<TownEvent, { k: K }>;
void eventModules;  // imported for the augmentations
export const ACTIONS: ReadonlyMap<string, ActionDef> =
  new Map(actionModules.flatMap((m) => Object.values(m).filter(isActionDef)).map((d) => [d.type, d]));
